// Auto-generated config for dev environment
export const API_BASE_URL = 'https://bs.lyndus.com.br';
export const APP_USER_URL = 'https://appuser.lyndus.com.br';
export const BM_URL = 'https://bm.lyndus.com.br';
export const BS_URL = 'https://bs.lyndus.com.br';
export const CLIENT_URL = 'https://client.lyndus.com.br';
export const BONDER_URL = 'https://bonder.lyndus.com.br';
export const BANKING_URL = 'https://banking.lyndus.com.br';
export const ENVIRONMENT = 'dev';
export const IS_PRODUCTION = 'dev' === 'prod';

// Original config exported below for reference
export const API_URL = process.env.VUE_APP_API_URL
export default API_URL
